module.exports = __webpack_public_path__ + "static/media/smoothsole-1.ab1738b2.jpg";